import PCLNAnalytics from '@pcln/analytics'
import { validateParams } from '../../utils'

function logZeroRebookListingsResult(listingsLength) {
  if (listingsLength === 0) {
    PCLNAnalytics.logEvent({
      action: 'Search results returned: 0',
      category: 'mfly-listings',
      label: 'display',
    })
  }
}
function logMoreRebookListingsResults(listingsLength) {
  if (listingsLength > 0) {
    PCLNAnalytics.logEvent({
      action: `Search results returned: ${listingsLength}`,
      category: 'mfly-listings',
      label: 'display',
    })
  }
}

function logRebookListingsResult({ listingsLength, isReshopExperience }) {
  const isParamsValid = validateParams({
    params: arguments[0],
    paramsTypes: {
      listingsLength: 'number',
      isReshopExperience: 'boolean',
    },
    PCLNAnalytics,
    functionName: 'logRebookListingsResult',
    fileName: 'logGaEvent-rebook-listings.js',
  })
  if (!isParamsValid || !isReshopExperience) {
    return
  }
  logZeroRebookListingsResult(listingsLength)
  logMoreRebookListingsResults(listingsLength)
}

export { logRebookListingsResult }
